/* @generated */

// src/assets/ui-icon/line/create-stack.tsx
import * as React from "react";
var CreateStackLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 3.66 7.5 4.755L12 13.22 4.5 8.415 12 3.66ZM7.29 8.422 12 11.438l4.71-3.016L12 5.436 7.29 8.422Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m18.904 12.357-.808-1.263L12 14.998l-6.095-3.904-.81 1.263L12 16.779l6.904-4.422Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M14.102 17.215 12 18.56l-6.095-3.905-.81 1.263L12 20.342l2.102-1.346v-1.781Zm3.502 2.786v-2h-2v-1.5h2v-2h1.5v2h2v1.5h-2v2h-1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  CreateStackLine
};
